export default __webpack_public_path__ + "static/char-s-sp01-zh-Hans-0e1707f5efff796385cad5a6f40a5f33.png";